import { render, staticRenderFns } from "./agentTopUpOrder.vue?vue&type=template&id=799736d0&scoped=true&"
import script from "./agentTopUpOrder.vue?vue&type=script&lang=js&"
export * from "./agentTopUpOrder.vue?vue&type=script&lang=js&"
import style0 from "./agentTopUpOrder.vue?vue&type=style&index=0&id=799736d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799736d0",
  null
  
)

export default component.exports